import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Lenis from "lenis";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Agenda from "@/pages/admin/Agenda";
import Clientes from "@/pages/admin/Clientes";
import Servicos from "@/pages/admin/Servicos";
import Certificados from "@/pages/admin/Certificados";
import Receber from "@/pages/admin/Receber";
import Pagar from "@/pages/admin/Pagar";
import Relatorios from "@/pages/admin/Relatorios";
import Backup from "@/pages/admin/Backup";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return <div className="min-h-screen flex items-center justify-center bg-[#FAF9F5] text-stone-500 p-8 text-center">Algo deu errado nesta página. <button className="ml-2 underline" onClick={() => window.location.reload()}>Recarregar</button></div>;
    }
    return this.props.children;
  }
}

function LenisScroll() {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname !== "/") return undefined;
    const lenis = new Lenis({ lerp: 0.09 });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, [location.pathname]);
  return null;
}

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAF9F5]">
        <div className="font-display text-2xl text-stone-400">Carregando…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AdminShell() {
  return (
    <AdminLayout>
      <Routes>
        <Route index element={<Navigate to="/app/agenda" replace />} />
        <Route path="agenda" element={<Agenda />} />
        <Route path="clientes" element={<Clientes />} />
        <Route path="servicos" element={<Servicos />} />
        <Route path="certificados" element={<Certificados />} />
        <Route path="receber" element={<Receber />} />
        <Route path="pagar" element={<Pagar />} />
        <Route path="relatorios" element={<Relatorios />} />
        <Route path="backup" element={<Backup />} />
      </Routes>
    </AdminLayout>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/app/*"
        element={
          <ProtectedRoute>
            <AdminShell />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <LenisScroll />
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
